import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';
import InstaIcon from 'react-icons/lib/fa/instagram';

const Wrapper = Flex.extend`
  max-width: 1300px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 120px auto;
  transition: all .5s;

  ${media.mobile`
    margin: 90px auto 77px;
  `}
`;

/** Left 4 Images */
const PicContainer = styled.div`
  width: 55%;
  flex-direction: column;
  flex-wrap: wrap;
  transition: all .5s;

  ${media.tablet`
    width: 100%;
    justify-content: space-around;

    & > div {
      text-align: center;
    }
  `}
  ${media.mobile`
    & > div {
      padding: 0 10px;
      justify-content: space-between;
    }
  `}
`;

const Img = styled.img`
  display: inline-block;
  max-width: 360px;
  width: 100%;
  height: 100%;
`;

/** Right Text */
const Column = styled.div`
  width: 470px;
  height: 460px;
  margin: 50px 0 0 0;
  transition: all .5s;

  & > h1 {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.43;
    letter-spacing: 2.4px;
    color: #333333;
  }

  & > p {
    font-family: 'Noto Sans KR', sans-serif;
    width: 360px;
    font-size: 17px;
    font-weight: 300;
    line-height: 1.76;
    margin-top: 65px;
    color: #333333;
    word-break: keep-all
  }

  .mobile {
    display: none;
  }

  ${media.tablet`
    height: auto;
  `}
  ${media.mobile`
    margin: 34px 40px 0;

    & > h1 {
      font-size: 21px;
      line-height: 1.35;
      letter-spacing: 2px;
    }
    & > p {
      width: 295px;
      margin-top: 29px;
      font-size: 14px;
      font-weight: 400;
      line-height: 2.0;
    }

    .desk {
      display: none;
    }
    .mobile {
      display: inline-block;
    }
  `}
  ${media.se`
    & > h1 { font-size: 17px; }
  `}
`;

/** Instagram */
const Instagram = Flex.extend`
  width: 200px;
  justify-content: flex-start;
  margin-top: 20px;
  color: #9e9e9e;
  font-size: 15px;
  letter-spacing: 0.8px;

  & div {
    display: flex;
    justify-content: center;
    align-items: center;
    float: left;
    width: 40px;
    height: 40px;
    font-size: 18px;
    background-color: #ffffff;
    border: solid 1px #eeeeee;
    border-radius: 50%;
  }
`;

const InstaTargetLink = styled.span`
  line-height: 40px;
  font-size: 13px;
`;

const InstaItem = styled.div`
  display: inline-block;
  max-width: 360px;
  width: 48%;
  height: 48%;
  height: auto;
  margin: 1% 1% 0;

  ${media.mobile`
    width: 45%;
    height: 45%;
    margin: 6px 6px 0;
  `}
`;

const InstaItemLogoStyle = styled.div`
  font-size: 16px;
  border: none !important;
  border-radius: 0;
  margin-right: 7px;

  & > img {
    border: none;
  }

  ${media.mobile`
    width: 25px !important;
    height: 25px !important;
  `}
`;

const InstaItemTargetLink = styled.span`
  line-height: 40px;
  font-size: 13px;
  color: #000;

  ${media.mobile`
    font-size: 10px;
    line-height: 25px;
  `}
`;

const InstaItemTitle = () => (
  <Instagram style={{margin: '0 0 10px'}}>
    <a href="https://www.instagram.com/gurmbyh_official" target="_blank" rel="noopener noreferrer">
      <InstaItemLogoStyle><img src="/images/home/instalogo.svg" width="100%" alt=""/></InstaItemLogoStyle>
      <InstaItemTargetLink>gurmbyh_official</InstaItemTargetLink>
    </a>
  </Instagram>
);

class Insta extends PureComponent {
  render() {
    const { homeData } = this.props;

    return (
      <Wrapper>
        <PicContainer>
          <div style={{height: '100%'}}>
            <InstaItem>
              <InstaItemTitle/>
              <a href="https://www.instagram.com/gurmbyh_official" target="_blank" rel="noopener noreferrer">
                <Img src={homeData.instaImages1 && homeData.instaImages1.url} alt=""/>
              </a>
            </InstaItem>
            <InstaItem>
              <InstaItemTitle/>
              <a href="https://www.instagram.com/gurmbyh_official" target="_blank" rel="noopener noreferrer">
                <Img src={homeData.instaImages2 && homeData.instaImages2.url} alt=""/>
              </a>
            </InstaItem>
          </div>
          <div style={{height: '100%'}}>
            <InstaItem>
              <InstaItemTitle/>
              <a href="https://www.instagram.com/gurmbyh_official" target="_blank" rel="noopener noreferrer">
                <Img src={homeData.instaImages3 && homeData.instaImages3.url} alt=""/>
              </a>
            </InstaItem>
            <InstaItem>
              <InstaItemTitle/>
              <a href="https://www.instagram.com/gurmbyh_official" target="_blank" rel="noopener noreferrer">
                <Img src={homeData.instaImages4 && homeData.instaImages4.url} alt=""/>
              </a>
            </InstaItem>
          </div>
        </PicContainer>
        <Column>
          <Instagram style={{marginBottom: '20px'}}><a href="https://www.instagram.com/gurmbyh_official" target="_blank" rel="noopener noreferrer"><div><InstaIcon/></div><InstaTargetLink> &nbsp; &nbsp;@gurmbyh_official</InstaTargetLink></a></Instagram>
          <h1 className="desk">FOLLOW ON<br/>GURM BY H &amp; BABY DEEDEE</h1>
          <h1 className="mobile">FOLLOW ON GURM BY H<br/>&amp; BABY DEEDEE</h1>
          <p>GBH의 베이비&amp;키즈라인GurmbyH는 '아이는 아이답게'라는 모토로 편안함과 유쾌함에 초점을 맞춘 베이비&amp;키즈웨어를 소개하고 있습니다.<br/>편안하고 실용적인 자체 제작 제품을 만나보세요.</p>
        </Column>
      </Wrapper>
    );
  }
}

export default Insta;



// WEBPACK FOOTER //
// ./src/components/Home/Insta.js